<!-- Conditional Dashboard Rendering with @if() directive -->
@if (isGenericFlow) {
  <app-generic-dashboard></app-generic-dashboard>
} @else {
  <app-education-dashboard></app-education-dashboard>
}
